require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-personal-shared-branching.json") })
        }
      }, "path---es-personal-shared-branching");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-personal-shared-branching!./.cache/json/es-personal-shared-branching.json
// module id = 2598
// module chunks = 231608221292675